export enum DocsVerificationStepEnum {
    START = 'start',
    VERIFICATION = 'verification',
    FINISH = 'finish',
    EXPIRED = 'expired',
    DESKTOP_NOT_ALLOWED = 'desktopNotAllowed',
}
